import type { ConceptDef } from '../types';

export const echoicRhymes: ConceptDef = {
  kind: 'supervisorScored',
  id: 'echoic-rhymes',
  label: 'Echoic Rhymes',
  category: 'Echoic',
  description: 'Speak a rhyming pair; learner repeats it. Supervisor scores.',
  config: {
    promptMode: 'AUDIO',
    prompts: [
      { prompt: 'cat, hat' },
      { prompt: 'star, car' },
      { prompt: 'tree, bee' },
      { prompt: 'sun, fun' },
      { prompt: 'cake, lake' },
      { prompt: 'goat, boat' },
    ],
  },
};
